import { render, staticRenderFns } from "./DetailPage.vue?vue&type=template&id=0d68c5a4&scoped=true&"
import script from "./DetailPage.vue?vue&type=script&lang=js&"
export * from "./DetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d68c5a4",
  null
  
)

export default component.exports